export enum ProductTypesEnum {
  LOAN = 'loan_type',
  DEPOSITS = 'deposit_type',
  ACCOUNTS = 'account_type',
  FINANCING = 'financing',
  CARDS = 'card_type',
  SERVICES = 'services',
  'special-offer' = 'special-offer',
  PRODUCT_MORE = 'product_more_type',
}
